import React from 'react'
import "./noOneElement.scss";

import { Stack } from 'react-bootstrap'
import { t } from 'i18next';
import { Link } from 'react-router-dom';

const NoOneElement = ({ title, subtitle, image, explore = false }) => {
    return (
        <div>
            <Stack className="stack-no-one-element" gap={3}>
                <span className='title'>{title}</span>
                <span className='subtitle'>{subtitle}</span>
                {image ? <img src={image} alt="noOneElementImage" /> : null}
                {explore ?
                    <span className="lnr lnr-magnifier"
                        style={{
                            fontSize: "25px",
                            color: "black",
                        }}>
                    </span>
                    : null}
                {explore ? <Link to="/list-associations" className='explore-link'>{t("common.explore_association_near")}</Link> : null}
            </Stack>
        </div>
    )
}

export default NoOneElement
